import type { FormInputProps } from '@tix/ds/components/atoms/form-input/types.ts'

import { getDefaultCountry } from './getDefaultCountry'
import type { IdentityFormData, IdentityFormField } from './identityHelpers'
import { isGiftAidFieldKey } from './identityHelpers'

export function mapIdentityFieldsToFormInput(
  fields: IdentityFormField[],
  answers: IdentityFormData = {},
): FormInputProps[] {
  return fields.map((field) => {
    const base: FormInputProps = {
      id: field.key,
      type: 'string',
      label: field.labelHtml ?? field.label ?? field.key,
      required: field.required,
      disabled: field.disabled,
      readOnly: field.readOnly,
      maxlength: field.maxlength,
    }

    if (isGiftAidFieldKey(field.key)) {
      return {
        ...base,
        label: field.description ?? field.label,
      }
    }

    switch (field.type) {
      case 'email':
        return {
          ...base,
          type: 'email',
        }
      case 'password':
        return {
          ...base,
          type: 'password',
        }
      case 'tel':
      case 'phone-number':
        return {
          ...base,
          type: 'tel',
          defaultCountry: getDefaultCountry(String(answers[field.key] ?? '')),
        }
      case 'country':
        return {
          ...base,
          type: 'country',
        }
      case 'select':
      case 'options':
        return {
          ...base,
          type: 'select',
          options: field.options ?? [],
        }
      case 'checkbox':
        return {
          ...base,
          type: 'checkbox',
          label: field.description ?? field.label,
        }
      default:
        return {
          ...base,
          type: 'string',
        }
    }
  })
}
